<template>
  <AppBar title="Local login" />
  <div v-if="localAccount">
    You are logged in as {{ localAccount.username }}.
  </div>
  <v-card>
    <v-card-text>
      <form ref="form" @submit.prevent="login()">
        <v-text-field
          v-model="username"
          label="username"
          name="username"
          placeholder="username"
          required
          type="text"
        />
        <v-text-field
          v-model="password"
          label="password"
          name="password"
          placeholder="password"
          required
          type="password"
        />
        <v-btn
          color="primary"
          :disabled="submitDisabled"
          type="submit"
          value="log in"
          >Login</v-btn
        >
      </form>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { localAccount, setAccount } from "../authenticationTokens";
import { usersCreateToken } from "../gen/observations-vue";

const username = ref("");
const password = ref("");
const submitDisabled = computed(() => {
  return !(username.value && password.value);
});

async function login() {
  if (submitDisabled.value) {
    return;
  }
  const authorization = "Basic " + btoa(`${username.value}:${password.value}`);
  const options = {
    baseURL: "/api/",
    headers: { Authorization: authorization },
  };
  const token = await usersCreateToken(username.value, options);
  const tokenString: unknown = JSON.parse(token.data);
  if (typeof tokenString === "string") {
    setAccount({
      server: window.location.host,
      token_name: window.location.host,
      token: tokenString,
      username: username.value,
      uid: -1,
      enabled: true,
      repositories: [],
    });
  }
}
</script>
